import { snackbar } from '@occc-app/design-system';

import {
  useSetLocationPerformanceGoalMutation,
  useUnsetLocationPerformanceGoalMutation,
} from '../../../../data-access/mutations';
import { MonthlyPerformanceGoalFormValues } from '../components/specific-goals-dialog/specific-goals-dialog.types';

type UseSetLocationSpecificGoalsArgs = {
  locationUuid: string;
  retailerNetworkUuid: string;
};

export type UseSetLocationSpecificGoalsReturnType = (
  values: MonthlyPerformanceGoalFormValues,
) => Promise<void>;

export const useSetLocationSpecificGoals = ({
  locationUuid,
  retailerNetworkUuid,
}: UseSetLocationSpecificGoalsArgs): UseSetLocationSpecificGoalsReturnType => {
  const onCompleted = () => snackbar.success('Goals has been updated');
  const onError = () => snackbar.error('Unable to update goals. Please try again');

  const [setLocationPerformanceGoalMutation] = useSetLocationPerformanceGoalMutation({
    onCompleted,
    onError,
    refetchQueries: [
      'retailerNetworkPerformance',
      'retailerNetworkLocationsWithPerformanceExcerpt',
    ],
  });
  const [unsetLocationPerformanceGoalMutation] = useUnsetLocationPerformanceGoalMutation({
    onCompleted,
    onError,
    refetchQueries: [
      'retailerNetworkPerformance',
      'retailerNetworkLocationsWithPerformanceExcerpt',
    ],
  });

  const setLocationSpecificGoal = async (values: MonthlyPerformanceGoalFormValues) => {
    if (values.inheritRetailerNetworkGoals) {
      await unsetLocationPerformanceGoalMutation({
        variables: {
          locationUuid,
          retailerNetworkUuid,
        },
      });
    } else {
      await setLocationPerformanceGoalMutation({
        variables: {
          input: {
            locationUuid,
            retailerNetworkUuid,
            loyaltyTransactionsGoal: values.transactionsPerStore,
            newMembersGoal: values.membersPerStore,
          },
        },
      });
    }
  };

  return setLocationSpecificGoal;
};
